<header wdNavbarHeight>
<wd-dev-warning-banner [isDevelopment]="dbConfig.isDevelopment" [label]="'Datenbank: ' + dbConfig.punkteDbName"></wd-dev-warning-banner>
<bp-pwa-install-banner></bp-pwa-install-banner>
<nav class="navbar navbar-expand-lg navbar-light bg-light" [ngClass]="{'local': oms.offlineMode()}">
	<div class="container-fluid d-flex justify-content-between align-items-center flex-nowrap overflow-visible gap-2">
		<div class="d-flex align-items-center gap-1">
			<button [disabled]="ds.isBusy" type="button" class="btn btn-default btn-home" (click)="onHomeClick($event)" placement="end" [ngbTooltip]="`BpWeb ${version}`">
				<bi name="house"></bi><span class="d-none d-md-inline bp-version">BpWeb {{ version }}</span>
				<span *ngIf="us.updateReady()" class="update-badge"></span>
			</button>
			<button type="button" class="btn btn-default btn-changelog" (click)="openChangelog()" title="Neuigkeiten">
				<i class="bi bi-journal"></i>
				<span *ngIf="cls.hasUnread()" class="changelog-badge"></span>
			</button>
		</div>
		<div>
			<div class="btn-group" role="group">
				<ng-container *ngIf="canEdit() | async">
					<button *ngIf="ns.isActive(C.savePoint)" [disabled]="ds.isBusy || networkUnavailable()" type="button" class="btn btn-default"
						(click)="ns.command(C.savePoint).emit()" [title]="networkUnavailable() ? 'Keine Netzwerkverbindung' : 'Punkt Speichern'">
						<span class="d-none d-md-inline">Punkt Speichern</span> &nbsp;<bi name="download"></bi>
					</button>
				</ng-container>

				<!-- Zurück-Buttons (immer sichtbar, nicht nur für Bearbeiter) -->
				<button *ngIf="ns.isActive(C.goBack)" [disabled]="ds.isBusy" type="button" class="btn btn-default"
					(click)="ns.command(C.goBack).emit()" title="Zurück">
					<span class="d-none d-md-inline">Zurück</span> &nbsp;<bi name="arrow-left"></bi>
				</button>
				<button *ngIf="ns.isActive(C.goBackToPoint)" [disabled]="ds.isBusy" type="button" class="btn btn-default"
					(click)="ns.command(C.goBackToPoint).emit()" title="Zurück zum Punkt">
					<span class="d-none d-md-inline">Zurück</span> &nbsp;<bi name="arrow-left"></bi>
				</button>

				<!-- Fehler-Badges (Library-Komponenten) -->
				@if (isDeveloper()) {
					<wd-error-badge mode="all"></wd-error-badge>
				}
				@if (isProjectManager() || isDeveloper()) {
					<wd-error-badge mode="unknown"></wd-error-badge>
				}
				<!-- Status-Indikatoren (Library-Komponenten) -->
				<wd-storage-status></wd-storage-status>
				<wd-connection-status></wd-connection-status>
				<wd-gps-status (gpsClicked)="onGpsHome()"></wd-gps-status>
				<div ngbDropdown container="body" placement="bottom-end" display="dynamic"
					class="d-inline-block position-static">
					<button type="button" class="btn btn-secondary" id="bp-dropdown" ngbDropdownToggle title="Weitere Optionen">
						<bi name="list"></bi>
					</button>
					<div ngbDropdownMenu aria-labelledby="bp-dropdown">
						<button ngbDropdownItem *ngIf="ns.isActive(C.savePoint)" [disabled]="ds.isBusy || networkUnavailable()" type="button"
							class="btn btn-success" (click)="ns.command(C.savePoint).emit()" [title]="networkUnavailable() ? 'Keine Netzwerkverbindung' : 'Punkt Speichern'">
							<bi name="download"></bi>&nbsp;Punkt Speichern
						</button>
						<hr *ngIf="ns.isActive(C.savePoint)">
						<button ngbDropdownItem *ngIf="ns.isActive(C.discardPoint)" [disabled]="ds.isBusy" type="button" class="btn"
							(click)="ns.command(C.discardPoint).emit()" title="Verwerfen">
							<bi name="x"></bi>&nbsp;Verwerfen
						</button>
						<button ngbDropdownItem *ngIf="ns.isActive(C.goBack)" [disabled]="ds.isBusy" type="button" class="btn"
							(click)="ns.command(C.goBack).emit()" title="Zurück">
							<bi name="arrow-left"></bi>&nbsp;Zurück
						</button>
						<hr *ngIf="ns.isActive(C.discardPoint) || ns.isActive(C.goBack)">
						<button ngbDropdownItem *ngIf="ns.isActive(C.goBackToPoint)" [disabled]="ds.isBusy" type="button"
							class="btn" (click)="ns.command(C.goBackToPoint).emit()" title="Zurück zum Punkt">
							<bi name="arrow-left"></bi>&nbsp;Zurück
						</button>
						<hr *ngIf="ns.isActive(C.goBackToPoint)">
						<button ngbDropdownItem *ngIf="ns.isActive(C.addPoint) && hasProject()" [disabled]="ds.isBusy || networkUnavailable()" type="button" class="btn"
							(click)="ns.command(C.addPoint).emit()" [title]="networkUnavailable() ? 'Keine Netzwerkverbindung' : 'Neuer Punkt'">
							<bi name="plus"></bi>&nbsp;Neuer Punkt
						</button>
						<hr *ngIf="ns.isActive(C.addPoint) && hasProject()">
						<button ngbDropdownItem *ngIf="ns.isActive(C.assignSelectionToProject) && !isGuest()" [disabled]="ds.isBusy || networkUnavailable()" type="button" class="btn"
							(click)="ns.command(C.assignSelectionToProject).emit()" [title]="networkUnavailable() ? 'Keine Netzwerkverbindung' : 'Ausgewählte Punkte dem Projekt zuordnen'">
							<bi name="folder-plus"></bi>&nbsp;Auswahl zum Projekt
						</button>
						<button ngbDropdownItem *ngIf="ns.isActive(C.removeSelectionFromProject) && !isGuest()" [disabled]="ds.isBusy || networkUnavailable()" type="button" class="btn"
							(click)="ns.command(C.removeSelectionFromProject).emit()" [title]="networkUnavailable() ? 'Keine Netzwerkverbindung' : 'Ausgewählte Punkte aus dem Projekt entfernen'">
							<bi name="folder-minus"></bi>&nbsp;Auswahl aus Projekt entf.
						</button>
						<hr *ngIf="(ns.isActive(C.assignSelectionToProject) || ns.isActive(C.removeSelectionFromProject)) && !isGuest()">
						<button ngbDropdownItem *ngIf="ns.isActive(C.deleteSelection)" [disabled]="ds.isBusy || networkUnavailable()" type="button" class="btn"
							(click)="ns.command(C.deleteSelection).emit()" [title]="networkUnavailable() ? 'Keine Netzwerkverbindung' : 'Ausgewählte Punkte löschen'">
							<bi name="trash"></bi>&nbsp;Auswahl löschen
						</button>
						<hr *ngIf="ns.isActive(C.deleteSelection)">
						<button ngbDropdownItem *ngIf="ns.isActive(C.deletePoint)" [disabled]="ds.isBusy || networkUnavailable()" type="button" class="btn"
							(click)="ns.command(C.deletePoint).emit()" [title]="networkUnavailable() ? 'Keine Netzwerkverbindung' : 'Punkt löschen'">
							<bi name="trash"></bi>&nbsp;Punkt löschen
						</button>
						<hr *ngIf="ns.isActive(C.deletePoint)">
						<!-- Offline-Modus: Synchronisieren -->
						<ng-container *ngIf="oms.offlineMode() && ns.isActive(C.checkIn)">
							<button ngbDropdownItem
								[disabled]="ds.isBusy" type="button" class="btn" (click)="onSync()" title="Änderungen synchronisieren">
								<bi name="arrow-repeat"></bi>&nbsp; Synchronisieren
							</button>
							<hr>
						</ng-container>
						<!-- Import-Assistent: WIP für normale User, aktiv für Entwickler -->
						<span *ngIf="ns.isActive(C.importWizard) && !isDeveloper()" ngbTooltip="Work in Progress" container="body">
							<button ngbDropdownItem [disabled]="true" type="button" class="btn">
								<bi name="box-arrow-in-down"></bi>&nbsp;Import-Assistent
							</button>
						</span>
						<button ngbDropdownItem *ngIf="ns.isActive(C.importWizard) && isDeveloper()" [disabled]="ds.isBusy" type="button"
							class="btn" (click)="ns.command(C.importWizard).emit()">
							<bi name="box-arrow-in-down"></bi>&nbsp;Import-Assistent
						</button>
						<button ngbDropdownItem *ngIf="ns.isActive(C.importDirectories)" [disabled]="ds.isBusy" type="button"
							class="btn" (click)="ns.command(C.importDirectories).emit()">
							<bi name="file-earmark-arrow-down"></bi>&nbsp;Import (Verzeichnisse)
						</button>
						<button ngbDropdownItem *ngIf="ns.isActive(C.importFiles)" [disabled]="ds.isBusy" type="button"
							class="btn" (click)="ns.command(C.importFiles).emit()">
							<bi name="file-earmark-arrow-down"></bi>&nbsp;Import (Dateien)
						</button>
						<button ngbDropdownItem *ngIf="ns.isActive(C.reimportProtocols)" [disabled]="ds.isBusy" type="button"
							class="btn" title="Protokoll-Export-Datei reimportieren" (click)="ns.command(C.reimportProtocols).emit()">
							<bi name="file-earmark-arrow-up"></bi>&nbsp;Reimport Protokolle
						</button>
						<hr *ngIf="ns.isActive(C.importWizard) || ns.isActive(C.importDirectories) || ns.isActive(C.importFiles) || ns.isActive(C.reimportProtocols)">
						<!-- Export-Funktionen für alle Benutzer mit geladenem Projekt (Gäste erhalten maskierte Daten) -->
						<ng-container *ngIf="hasProject()">
							<button ngbDropdownItem *ngIf="ns.isActive(C.backupData)" [disabled]="ds.isBusy" type="button" class="btn"
								title="Geo- und Sachdaten als Backup exportieren"
								(click)="ns.command(C.backupData).emit()">
								<bi name="download"></bi>&nbsp; Backup Geo- und Sachdaten
							</button>
							<button ngbDropdownItem *ngIf="ns.isActive(C.exportPdf)" [disabled]="ds.isBusy" type="button" class="btn" title="Ausgewählte Punkte als PDF exportieren"
								(click)="ns.command(C.exportPdf).emit()">
								<bi name="file-pdf"></bi>&nbsp; Export als PDF
							</button>
							<hr *ngIf="ns.isActive(C.backupData) || ns.isActive(C.exportPdf)">
						</ng-container>
						<a ngbDropdownItem type="button" class="btn" routerLink="/handbuch" title="Handbuch">
							<bi name="book"></bi>&nbsp; Handbuch
						</a>
						<!-- Listenverwaltung für Entwickler -->
						<a ngbDropdownItem *ngIf="isDeveloper()" type="button" class="btn" routerLink="/listenverwaltung" title="Listenverwaltung">
							<bi name="list-ul"></bi>&nbsp; Listenverwaltung
						</a>
						<!-- Listenverwaltung für andere Rollen: Work in Progress -->
						<span *ngIf="currentRole() && !isDeveloper()" ngbTooltip="Work in Progress" container="body">
							<button ngbDropdownItem [disabled]="true" type="button" class="btn">
								<bi name="list-ul"></bi>&nbsp; Listenverwaltung
							</button>
						</span>
						<hr>
						<button ngbDropdownItem *ngIf="ns.isActive(C.cleanUp) && (isProjectManager() || isDeveloper())" [disabled]="ds.isBusy" type="button" class="btn"
							(click)="ns.command(C.cleanUp).emit()">
							<bi name="trash"></bi>&nbsp; Lokalen Speicher Bereinigen
						</button>
						<hr *ngIf="ns.isActive(C.cleanUp) && isDeveloper()">
						<div *ngIf="currentRole()" ngbDropdown display="dynamic" class="d-inline-block">
							<button type="button" class="btn" id="role-dropdown" ngbDropdownToggle [disabled]="!multipleRoles()">
								<bi name="person-badge"></bi> &nbsp;{{currentUser()}} (<span class="capitalized">{{currentRole()}}</span>)
							</button>
							<div *ngIf="multipleRoles()" ngbDropdownMenu aria-labelledby="role-dropdown">
								<ng-container *ngFor="let r of aus.getRoles()">
									<button *ngIf="r !== currentRole()" ngbDropdownItem [disabled]="!multipleRoles()" type="button"
										class="btn btn-success" (click)="switchRole(r)">
										<span class="capitalized">{{r}}</span>
									</button>
								</ng-container>
							</div>
						</div>
						<bp-auth-button *ngIf="!oms.offlineMode()" (loggedOut)="onLoggedOut()"></bp-auth-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</nav>
</header>
